module.exports = __webpack_public_path__ + "img/fr-round.11de5eda.svg";